import { render, staticRenderFns } from "./productTopic.vue?vue&type=template&id=ae381f3a&"
import script from "./productTopic.vue?vue&type=script&lang=js&"
export * from "./productTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports